// Design System Button Styles
.ds-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-family: Avenir, sans-serif;
    font-weight: 600;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    border: none;
    outline: none;

    // Remove background from spans
    span {
        background: none !important;
    }

    // Uppercase text
    &--uppercase {
        text-transform: uppercase;
    }

    // Size variants
    &--small {
        height: 28px;
        padding: 0 12px;
        font-size: 11px;
    }

    &--medium {
        height: 36px;
        padding: 0 20px;
        font-size: 13px;
    }

    &--large {
        height: 44px;
        padding: 0 28px;
        font-size: 14px;
    }

    // Primary variant (black background)
    &--primary {
        background-color: #1b1b1b;
        color: #fff;
        border: none;

        &:hover:not(.ds-button--disabled):not(.ds-button--loading) {
            background-color: #fad133;
            color: #1b1b1b;

            .ds-button__icon {
                color: #1b1b1b !important;
            }
        }

        .ds-button__icon {
            color: #fff;
        }
    }

    // Secondary variant (outline)
    &--secondary {
        background-color: transparent;
        color: #1b1b1b;
        border: 1px solid #1b1b1b;

        &:hover:not(.ds-button--disabled):not(.ds-button--loading) {
            background-color: #1b1b1b;
            color: #fff;

            .ds-button__icon {
                color: #fff !important;
            }
        }

        .ds-button__icon {
            color: #1b1b1b;
        }
    }

    // Danger variant (red background)
    &--danger {
        background-color: #FD3635;
        color: #fff;
        border: none;

        &:hover:not(.ds-button--disabled):not(.ds-button--loading) {
            background-color: #e0302f;

            .ds-button__icon {
                color: #fff !important;
            }
        }

        .ds-button__icon {
            color: #fff;
        }
    }

    // Disabled state
    &--disabled {
        opacity: 0.2;
        cursor: not-allowed;
        pointer-events: auto; // Allow hover for tooltip

        &:hover {
            opacity: 0.3; // Slight feedback on hover
        }
    }

    // Loading state
    &--loading {
        cursor: wait;
        pointer-events: none;
    }

    // Icon
    &__icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: inherit;
        transition: color 0.2s ease;
    }

    // Text
    &__text {
        display: inline-block;
        font-weight: 600;
    }

    // Spinner
    &__spinner {
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    &__spinner-icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        border: 2px solid currentColor;
        border-top-color: transparent;
        border-radius: 50%;
        animation: ds-button-spin 0.6s linear infinite;
    }

    @keyframes ds-button-spin {
        to {
            transform: rotate(360deg);
        }
    }

    // Focus state (accessibility)
    &:focus-visible {
        outline: 2px solid #fad133;
        outline-offset: 2px;
    }
}
